 export default class Index {

    private el: HTMLElement;

    constructor() {
        this.el = document.createElement('div');

        if (window.userData?.isLogin) {
            this.setting();
        }
    }
    
    setting(){
        let msg = this.checkMsg()
        if ( !msg ) return;
        this.template( msg );
        document.body.appendChild( this.el );
        this.addEvents();
    }

    checkMsg(): string {
        let msg = '';
        window.userData.accountState.map( it =>{
            if(it.case==7 || it.case==8) msg = it.msg;
        });
        return msg;
    }

    template(_msg: string): void {
        this.el.id = "id-verify";
        this.el.classList.add("id-verify");
        this.el.innerHTML = `
        <div class="id-verify__wrapper" data-testid="id-verify">
            ${_msg}<button class="id-verify__close"><span class="blind">X</span></button>
        </div>`;
    }

    addEvents(){
        document.querySelector(".id-verify__close")?.addEventListener('click', e =>{
            this.el?.parentNode?.removeChild(this.el);
        });
    }

} // end of class